import { SocItem } from "../../../domain/SocItem";
import { Grid, Typography } from "@material-ui/core";
import { SectionProps } from "../SectionProps";
import { Controller } from "react-hook-form";
import { Error } from "../../common/Error";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { fieldLabels } from "../fieldLabels";

export const QuestionFourSection: React.FC<SectionProps<SocItem>> = (
  sectionProps
) => {
  const { control, disabled, errors } = sectionProps;

  return (
    <Grid item xs={12} sm={12}>
      <Typography variant="body1">
        How do you anticipate inflationary pressures impacting on your
        operations over the next 12 months? What plans are in place to mitigate
        the risks?
      </Typography>
      <Controller
        control={control}
        rules={{ maxLength: 5000, required: true }}
        name="inflationImpact"
        as={
          <TextField
            label={fieldLabels.inflationMitigationDetails}
            readOnly={disabled}
            data-test="inflationImpact-field"
            rows={8}
            multiline
            required
          />
        }
      />
      {errors.inflationImpact?.type === "maxLength" && (
        <Error data-test="inflationImpact-validation">
          Must be no more than 5,000 characters
        </Error>
      )}
      {errors.inflationImpact?.type === "required" && (
        <Error data-test="inflationImpact-validation">
          This field is required
        </Error>
      )}
    </Grid>
  );
};
